<!-- 打印 -->
<template>
  <div
    class="bom-print"
    v-loading="isLoading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
  >
    <div v-if="isLoading" class="bom-print__loading-notice no-print">
      <el-alert
        :title="loadingText"
        type="info"
        :closable="false"
        show-icon
      ></el-alert>
    </div>
    <div class="no-print" style="text-align: right; padding: 10px; background: #fff;">
      <el-button
        @click="clickPrintBtn"
        :disabled="isStopPrint"
        type="primary"
        >打印</el-button
      >
    </div>
    <div
      v-if="failedIdList.length || (!isLoading && emptyMessage)"
      class="no-print"
      style="background-color: #fff; padding: 0 10px 10px;"
    >
      <el-alert
        v-if="failedIdList.length"
        :title="failedMessage"
        type="warning"
        :closable="false"
        show-icon
      ></el-alert>
      <el-alert
        v-if="!isLoading && emptyMessage"
        :title="emptyMessage"
        type="info"
        :closable="false"
        show-icon
        style="margin-top: 8px;"
      ></el-alert>
    </div>
    <div class="bom-print__paper" style="background-color: white; padding: 15pt 15pt 50pt 15pt">
      <div class="printArea p66-print__table">
        <div
          v-for="page in flatPrintPageList"
          :key="page.pageKey"
          :class="page.printType"
          class="p66-print__table__box"
        >
          <table-head
            :title="printTitle"
            :group="page.detail.serials"
            :plus="page.detail.masterMatDesc"
            :materialCode="page.detail.materialCode"
            :valueDesc="page.detail.categoryDesc"
            :materialDescCn="page.detail.materialDescCn"
            :currentDate="currentDate"
            :img="page.detail.imgUrl"
            :italyWaveCode="page.detail.waveCode"
            :italyMaterialCode="page.detail.italyMaterialCode"
            :brand="page.detail.brandCode"
            :innerRemark="page.detail.relationMatCode"
          ></table-head>

          <div class="print-table-content">
            <table-Body-Head
              :type="page.route"
              :italyColor="{}"
              :materialColorMapList="page.materialColorMapList"
              :brand="page.detail.brandCode"
            ></table-Body-Head>
            <tableBodyContent
              :tableRowNum="tableRowNum[page.route]"
              :type="page.route"
              :materialColorMapList="page.materialColorMapList"
              :sourceList="page.pageRows"
              :brand="page.detail.brandCode"
            ></tableBodyContent>
          </div>

          <table-bottom :user-name="userName"></table-bottom>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Portlet from "../../components/portlet/Portlet.vue"
// import FormContainer from "../../components/form/FormContainer.vue"
// import SelectInput from "../../components/form/SelectInput.vue"
// import TextInput from "../../components/form/TextInput.vue"
// import YearInput from "../../components/form/YearInput.vue"
// import DateInput from "../../components/form/DateInput.vue"
// import ImageInput from "../../components/image/ImageInput.vue"
// import MaterialInput from "../../components/bizComponents/MaterialInput.vue"
// import SingleCheckBoxInput from "../../components/form/SingleCheckBoxInput.vue"
// import PageBar from '../../components/page/PageBar.vue'
// import PageBarItem from '../../components/page/PageBarItem.vue'
// import PageToolBarButton from '../../components/page/PageToolBarButton.vue'
import { dateFormat, toFixed } from "src/store/utils.js";

import tableBottom from "./compoment/print-table-bottom";
import tableHead from "./compoment/print-table-head";
import tableBodyHead from "./compoment/print-table-body-head";
import tableBodyContent from "./compoment/print-table-body-content";
import { toHiPrint } from "@/common/print";
import { ACEPrint, BDPrint } from "./compoment/printConfig";
export default {
  data() {
    return {
      placeholder: "/static/resources/img/placeholder.png",
      // test: '/static/resources/img/test.jpeg',
      currentDate: dateFormat(new Date()),
      headStyle: {
        head: "display: inline-block;margin-top:0pt; font-size: 12px; display:flex;justify-content: space-between;align-items: center;",
        title:
          "margin-top:0pt;font-weight: bold;font-size: 20px;text-align: center",
        img: "width: auto;height: 55px;",
        table: "border-collapse:collapse;margin-top:5pt;width:100%;",
      },
      tableRowNum: {
        ACE: {
          vertical: 8, //竖
          horizontal: 5, // 横
        },
        BD: {
          vertical: 13,
          horizontal: 8,
        },
      },
      // series: '',
      // plus: ''
      sourceIdList: [],
      detailList: [],
      failedIdList: [],
      isLoading: false,
      currentLoadingId: "",
      currentLoadingIndex: 0,
    };
  },
  components: {
    // "portlet": Portlet,
    // "form-container": FormContainer,
    // "s-input": SelectInput,
    // "t-input": TextInput,
    // "y-input": YearInput,
    // "d-input": DateInput,
    // "i-input": ImageInput,
    // "m-input": MaterialInput,
    // "sc-input": SingleCheckBoxInput,
    // 'page-bar': PageBar,
    // 'page-bar-item': PageBarItem,
    // 'page-tool-bar-button': PageToolBarButton,
    tableBottom,
    tableHead,
    tableBodyHead,
    tableBodyContent,
  },
  created() {
    this.loadBomDetails();
  },
  computed: {
    route: function () {
      return this.$route.query.type == 'A' ? 'ACE' : 'BD';
    },
    o_enums: function () {
      return {};
    },

    userName: function () {
      // tapd ID1006917
      // 面料辅料打印时制单都是默认为当前操作打印的用户（当前登录用户）
      return this.$store.state.userInfo.adminUserName; // this.$store.state.auth.userName;todo
      // return this.$store.state.bom.bom.bomHeader.createdByName;
    },

    materialMaster: function () {
      return {}; //this.$store.state.bom.material.materialMaster;
    },
    // 标题
    printTitle() {
      if (this.route == "ACE") {
        return "生产用面料配置确认卡";
      } else {
        return "生产用辅料配制确认卡";
      }
    },
    printBlocks() {
      return this.detailList.map((item) => this.buildPrintBlock(item));
    },
    flatPrintPageList() {
      return this.printBlocks.reduce((pre, block) => {
        return pre.concat(
          block.pages.map((pageRows, pageIndex) => ({
            pageKey: `${block.id}-${pageIndex}`,
            id: block.id,
            detail: block.detail,
            route: block.route,
            materialColorMapList: block.materialColorMapList,
            printType: block.printType,
            pageRows,
          }))
        );
      }, []);
    },
    failedMessage() {
      return this.failedIdList.length
        ? `以下id获取失败，已从打印内容中排除：${this.failedIdList.join(",")}`
        : "";
    },
    loadingText() {
      if (!this.isLoading) return "";
      const total = this.sourceIdList.length || 0;
      if (!total) return "正在获取打印数据...";
      return `正在获取打印数据（${this.currentLoadingIndex}/${total}）：${this.currentLoadingId}`;
    },
    emptyMessage() {
      if (!this.sourceIdList.length) return "缺少有效id参数";
      if (!this.flatPrintPageList.length) return "未获取到可打印数据";
      return "";
    },
    url: function () {
      return "";
      // todo
    },
    BOMList: function () {
      return []; // this.$store.state.bomList.BOMList; todo
    },
    isStopPrint() {
      return this.isLoading || !this.flatPrintPageList.length;
    },
    hasAnyHorizontalPrint() {
      return this.printBlocks.some(
        (block) => block.materialColorMapList.length > 4
      );
    },
  },

  methods: {
    getProjectTypeList() {
      return this.$route.query.type == "A" ? ["A", "C", "E"] : ["B", "D"];
    },
    getIdList(idValue) {
      const list = String(idValue || "")
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
      return [...new Set(list)];
    },
    normalizeBomDetail(detail = {}) {
      return {
        ...detail,
        itemList: Array.isArray(detail.itemList) ? detail.itemList : [],
        materialColor: Array.isArray(detail.materialColor)
          ? detail.materialColor
          : [],
      };
    },
    fetchBomDetail(id) {
      return new Promise((resolve, reject) => {
        this.$apis.autoAPi
          .POST_BOM_QUERY_DETAIL({
            id,
            projectTypeList: this.getProjectTypeList(),
          })
          .done((res) => {
            if (res && res.data) {
              resolve(this.normalizeBomDetail(res.data));
              return;
            }
            reject(res || {});
          })
          .fail((err) => {
            reject(err || {});
          });
      });
    },
    buildMaterialColorMapList(detail) {
      return detail.materialColor.map((item) => ({ colorName: item }));
    },
    getPrintTypeByDetail(detail, materialColorMapList) {
      const type = this.route;
      const length = materialColorMapList.length;
      const brand = detail.brandCode;
      if (brand == "6") {
        if (type === "ACE" && length <= 4) {
          return "print-ace-vertical print-ace-vertical_6";
        }
        if (type === "ACE" && length > 4) {
          return "print-ace-horizontal print-ace-horizontal_6";
        }
        if (type === "BD" && length <= 4) {
          return "print-bd-vertical print-bd-vertical_6";
        }
        if (type === "BD" && length > 4) {
          return "print-bd-horizontal print-bd-horizontal_6";
        }
      } else {
        if (type === "ACE" && length <= 4) return "print-ace-vertical";
        if (type === "ACE" && length > 4) return "print-ace-horizontal";
        if (type === "BD" && length <= 4) return "print-bd-vertical";
        if (type === "BD" && length > 4) return "print-bd-horizontal";
      }
      return "";
    },
    buildPageRows(detail, materialColorMapList) {
      const type = this.route;
      let pageSize = this.tableRowNum[type].horizontal;
      if (materialColorMapList.length <= 4) {
        pageSize = this.tableRowNum[type].vertical;
      }
      const sourceList =
        type === "ACE"
          ? detail.itemList
          : detail.itemList.map((item) => ({
              ...item,
              bomType: 4,
            }));

      return sourceList.reduce((pre, next, index) => {
        if (index % pageSize === 0) {
          pre.push([]);
        }
        pre[pre.length - 1].push(next);
        return pre;
      }, []);
    },
    buildPrintBlock(item) {
      const materialColorMapList = this.buildMaterialColorMapList(item.detail);
      return {
        id: item.id,
        detail: item.detail,
        route: this.route,
        materialColorMapList,
        printType: this.getPrintTypeByDetail(item.detail, materialColorMapList),
        pages: this.buildPageRows(item.detail, materialColorMapList),
      };
    },
    async loadBomDetails() {
      const idList = this.getIdList(this.$route.query.id);
      this.sourceIdList = idList;
      this.detailList = [];
      this.failedIdList = [];
      this.currentLoadingId = "";
      this.currentLoadingIndex = 0;

      if (!idList.length) {
        this.$message.warning("缺少有效id参数");
        return;
      }

      this.isLoading = true;
      for (const [index, id] of idList.entries()) {
        this.currentLoadingIndex = index + 1;
        this.currentLoadingId = id;
        try {
          const detail = await this.fetchBomDetail(id);
          this.detailList.push({
            id,
            detail,
          });
        } catch (err) {
          this.failedIdList.push(id);
        }
      }
      this.isLoading = false;
      this.currentLoadingId = "";

      if (!this.flatPrintPageList.length) {
        this.$message.warning("未获取到可打印数据");
        return;
      }
      if (this.failedIdList.length) {
        this.$message.warning(this.failedMessage);
      }
    },
    // 截取‘款式’字符串，只要最后一项
    countString: function (str) {
      var param = str.split("-");
      return param[param.length - 1];
    },
    handlePrint() {
      const apgeType = this.route;
      let printTem = apgeType === "ACE" ? ACEPrint : BDPrint;
      const targetList = printTem.panels[0].printElements.find(
        (item) => item?.printElementType?.title === "表格"
      );
      const tableColumn = targetList.options.columns[0];
      const colorItem = tableColumn.find((item) => item.field === "color_0");
      const bom = this.$store.state.bom.bom;
      const o_enums = this.o_enums;
      let brands = ""; //this.BOMList.data[0].brandCode todo
      const {
        bomItemBOsA,
        bomItemBOsC,
        bomItemBOsE,
        bomItemBOsB,
        bomItemBOsD,
      } = bom;
      const dataSource =
        apgeType === "ACE"
          ? [...bomItemBOsA, ...bomItemBOsC, ...bomItemBOsE]
          : [...bomItemBOsB, ...bomItemBOsD];
      const printListAce = [...dataSource]
        .filter((item) => item?.bomItem?.deleteFlag == 0)
        .map((item) => {
          return {
            componentCode:
              item.bomItem.componentCode + "\n" + item.bomItem.componentDesc,
            componentDesc: item.bomItem.componentDesc,
            type:
              ["2", "3", "C"].includes(brands) && apgeType === "ACE"
                ? item.bomItem.patternAttribute
                : item.bomItem.componentType != null
                ? o_enums["BOMComponentType"][item.bomItem.componentType]
                    .valueDesc
                : "",
            practicalSealingWidth:
              apgeType === "ACE"
                ? item.bomItem.practicalSealingWidth
                : item.bomItem.standard,
            componentUsage: !(
              item.bomItem.makermakingStatus == 0 && apgeType === "ACE"
            )
              ? item.bomItem.componentUsage
                ? toFixed(item.bomItem.componentUsage, 3) +
                  item.bomItem.unitCode
                : ""
              : "",
            usedPosition: item.bomItem.usedPosition,
            remark: item.bomItem.remark,
            hasInput:
              item.bomItem.colorOptions != null
                ? item.bomItem.colorOptions.length > 0
                : false,
            bomItem: item.bomItem,
            source: item,
            bomType: item.bomType,
          };
        });

      function initData(printListAce = [], materialColorMapList = []) {
        const printTableData = printListAce.map((item, index) => {
          let colorList = item.bomItem.colorOptions.reduce((pre, cur) => {
            item.bomItem.colorValues.forEach((_item) => {
              if (cur.valueCode === _item) {
                pre.push(cur);
              }
              if (_item === "") {
                pre.push({
                  valueCode: "",
                  valueDesc: ``,
                });
              }
            });
            return pre;
          }, []);
          if (!materialColorMapList?.length) {
            colorItem.title = "通色";
            if (!colorList?.length) {
              item[
                "color_0"
              ] = `<span style="font-size: 20px;position: absolute;top:0">✔</span>`;
            }
          } else {
            materialColorMapList.reduce((pre, cur, index) => {
              const key = "color_" + index;
              pre[key] = cur.colorName;
              const target = tableColumn.find((item) => item.field === key);
              target.title = cur.colorName;
              return pre;
            }, {});
            if (!colorList?.length) {
              colorList = materialColorMapList.map((item) => {
                return {
                  valueCode: "",
                  valueDesc: `<span style="font-size: 20px;position: absolute;top:0">✔</span>`,
                };
              });
            }
          }
          const colorInfo = colorList.reduce((pre, cur, index) => {
            pre["color_" + index] = cur?.valueDesc + cur?.valueCode;
            return pre;
          }, {});
          return {
            ...item,
            ...colorInfo,
          };
        });
        return {
          printTableData,
        };
      }

      const { printTableData } = initData(
        printListAce,
        this.materialColorMapList
      );
      const printData = {
        valueDesc: this.o_enums["MaterialGroup"][
          this.materialMaster.materialGroup
        ]
          ? this.countString(
              this.o_enums["MaterialGroup"][this.materialMaster.materialGroup]
                .valueDesc
            )
          : "",
        title: this.printTitle,
        group: this.group,
        series: this.series,
        plus: this.plus,
        materialCode: this.materialMaster.materialCode,
        materialDescCn: this.materialMaster.materialDescCn,
        currentDate: this.currentDate,
        img: !this.materialMaster.imgUrl.productImg
          ? this.placeholder
          : this.url,
        italyWaveCode: this.italyData.waveCode,
        italyMaterialCode: this.italyData.italyMaterialCode,
        brand: this.materialMaster.brand,
        innerRemark: this.innerRemark,
        printData: printTableData,
        userName: this.userName,
      };
      return toHiPrint(printTem, printData);
    },
    // 点击打印
    clickPrintBtn: function () {
      if (this.isLoading) return;
      if (!this.flatPrintPageList.length) {
        this.$message.warning(this.emptyMessage || "没有可打印数据");
        return;
      }
      // let brands = this.bomDetail.brandCode
      // 6 暂定
      // if (brands !== "6") return this.handlePrint();
      if (this.hasAnyHorizontalPrint) {
        this.headStyle.img =
          "width: auto;height: 65px;transform: scale(1.2) translate(-20px, -10px);";
        setTimeout(() => {
          this.$alert("建议您横向打印! ", "", {
            confirmButtonText: "确定",
            type: "warning",
          })
            .then(() => {
              printCurrentPage();
            })
            .catch(() => {});
        }, 0);
      } else {
        printCurrentPage();
      }

      // 直接在当前页面打印：等待打印区域内图片加载完成后调用 window.print()
      // 版式缩放由 @media print 样式控制；页面留白用临时注入的 @page 控制，
      // 打印结束后立即移除，避免影响同一应用内其他打印页（如 hiPrint）
      async function printCurrentPage(el = "printArea") {
        const area = document.getElementsByClassName(el)[0];
        if (!area) return;

        const pageStyle = document.createElement("style");
        pageStyle.setAttribute("media", "print");
        pageStyle.textContent = "@page { margin: 16mm 10mm 0; }";
        document.head.appendChild(pageStyle);

        const removePageStyle = () => {
          if (pageStyle.parentNode) {
            pageStyle.parentNode.removeChild(pageStyle);
          }
          window.removeEventListener("afterprint", removePageStyle);
        };
        window.addEventListener("afterprint", removePageStyle);

        const images = Array.from(area.getElementsByTagName("img"));
        await Promise.all(
          images.map(async img => {
            if (!img.complete) {
              await new Promise(resolve => {
                img.onload = resolve;
                img.onerror = resolve;
              });
            }
            if (img.decode) {
              try {
                await img.decode();
              } catch (e) {
                console.warn("图片 decode 失败:", img.src, e);
              }
            }
          })
        );

        // 给浏览器两帧时间完成布局和绘制
        await new Promise(resolve =>
          requestAnimationFrame(() => {
            requestAnimationFrame(resolve);
          })
        );

        window.print();
      }
    },

    getImgUrl: function (imgUrl) {
      return window.configs.fileserverurl + imgUrl;
    },
  },
};
</script>


<style>
@import "./../../../../../../public/static/resources/table.css";
.bom-print__loading-notice {
  position: fixed;
  top: 16px;
  left: 50%;
  z-index: 3000;
  width: min(720px, calc(100vw - 32px));
  transform: translateX(-50%);
}

.printArea {
  width: 1280px;
  margin: 0 auto;
}

/* 直接在当前页面打印。所有规则均限定在 .bom-print 内部，避免污染其他打印页（如 hiPrint） */
@media print {
  /* 注意：@page 是文档级规则，无法用选择器限定，会影响同一应用内其他打印页（如 hiPrint），
     因此页面留白改为打印时动态注入，见 printCurrentPage */

  /* 隐藏 bom-print 内的打印按钮、提示等非打印元素 */
  .bom-print .no-print {
    display: none !important;
  }

  /* 去掉屏幕预览用的白底内边距，避免叠加到页面留白上 */
  .bom-print .bom-print__paper {
    padding: 0 !important;
  }

  /* 打印区留在正常文档流中（绝对定位会导致超高内容无法分页而被截断），
     去掉屏幕上的固定宽度与居中 */
  .bom-print .printArea {
    width: auto;
    margin: 0;
    padding: 0;
  }

  /* 版式盒子左对齐，不再居中 */
  .bom-print .p66-print__table__box {
    margin: 0;
  }

  /* 首页不需要分页符，否则会多出一张空白页 */
  .bom-print .p66-print__table__box:first-child {
    page-break-before: auto;
  }

  /* table.css 中各版式宽高按纸张满幅写死（横版 297mm = A4 全宽，竖版 210mm），
     加留白后必然超出并被截断。用 zoom 等比缩小以适配可打印区。
     zoom 会同时缩小布局尺寸，分页才能正确计算（transform: scale 不影响布局，无效）。 */

  /* 横版：可打印区 277mm × 194mm，内容 297mm × 209mm */
  .bom-print .print-ace-horizontal,
  .bom-print .print-ace-horizontal_6,
  .bom-print .print-bd-horizontal,
  .bom-print .print-bd-horizontal_6 {
    zoom: 0.92;
  }

  /* 竖版：可打印区 190mm × 281mm，内容 210mm × 297mm */
  .bom-print .print-ace-vertical,
  .bom-print .print-ace-vertical_6,
  .bom-print .print-bd-vertical,
  .bom-print .print-bd-vertical_6 {
    zoom: 0.9;
  }
}
</style>
